package com.macrofocus.eflux.ui.table

import com.macrofocus.common.units.Power
import com.macrofocus.common.units.Quantity
import com.macrofocus.eflux.network.crossborder.CrossborderBranches
import com.macrofocus.eflux.network.crossborder.CrossborderNetwork
import com.macrofocus.eflux.network.toFixed
import js.objects.unsafeJso
import mui.material.*
import mui.system.sx
import react.FC
import react.Props
import react.create
import web.cssom.BackgroundColor
import web.cssom.WhiteSpace
import web.cssom.px

external interface CrossborderTableProps : Props {
    var crossborderNetwork: CrossborderNetwork
    var lookup : (CrossborderBranches) -> Quantity<Power>?
    var transparent: BackgroundColor?
}

val CrossborderTable = FC<CrossborderTableProps> { props ->
    val crossborder = props.crossborderNetwork

    TableContainer {
        sx = unsafeJso {
            if(props.transparent != null) {
                backgroundColor = props.transparent
            }
//            height = 100.vh
        }

        component = Paper.create().type

        Table {
            sx = unsafeJso {
                minWidth = 650.px
                // Enable horizontal scrolling
//                    overflowX = Auto.auto
            }

            size = Size.small

            ariaLabel = "simple table"
            stickyHeader = true

            TableHead {
                TableRow {
                    TableCell {
                        +""
                    }
                    for (to in crossborder.nodes) {
                        TableCell {
                            align = TableCellAlign.right
                            +"${to}"
                        }
                    }
                }
            }
            if (crossborder != null) {
                TableBody {
                    for (from in crossborder.nodes) {
                        TableRow {
                            TableCell {
                                sx {
                                    whiteSpace = WhiteSpace.nowrap
                                }
                                //                                //                                                        component = ReactHTML.th
                                //                                //                                                        scope = "row"
                                //
                                val value = from
                                align = TableCellAlign.left
                                +(value.toString())
                            }
                            for (to in crossborder.nodes) {
                                val link = crossborder.getLink(from, to)
                                if(link != null) {
                                    TableCell {
                                        sx {
                                            whiteSpace = WhiteSpace.nowrap
                                        }
                                        //                                //                                                        component = ReactHTML.th
                                        //                                //                                                        scope = "row"
                                        //
                                        val value = props.lookup.invoke(link)
                                        if (value is Quantity<*>) {
                                            align = TableCellAlign.right
                                        }
                                        if (value != null) {
                                            val formattedValue = value.amount.toFixed(0) + " " + value.unit.symbol
                                            +formattedValue
                                        } else {
                                            +""
                                        }
                                    }
                                } else {
                                    TableCell {
                                        sx {
                                            whiteSpace = WhiteSpace.nowrap
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
